const env = import.meta.env;

export const baseUrl = env.VITE_OA_IMAGE_BASE_URL;
export const apiKey = env.VITE_API_KEY;
export const apiUrl = env.VITE_API_URL;
export const apiDownloadUrlGpx = env.VITE_API_DOWNLOAD_URL_GPX;
export const apiDownloadUrlKml = env.VITE_API_DOWNLOAD_URL_KML;
export const mapApiProjectKey = env.VITE_API_PROJECT_KEY;
export const mapApiKey = env.VITE_API_KEY;
export const apiCacheTtl = parseInt(env.VITE_OA_API_CACHE_TTL) || 0;

export { default as activities } from "./activities-mapping.json";
